import React from "react";
import {
    FormControl,
    FormControlLabel,
    FormHelperText,
    InputLabel,
    MenuItem,
    Select,
    Switch,
} from "@mui/material";
import { IMAGE_SOURCE_OPTIONS } from "./taskSchedulerConstants";

const IMAGE_SOURCE_SELECT_ID = {
    FACEBOOK_IMAGE_POST: "facebook-image-source-label",
    INSTAGRAM_IMAGE_POST: "instagram-image-source-label",
};

function ImagePostPayloadFields({ platformKey, payload, onPayloadChange }) {
    const selectId = IMAGE_SOURCE_SELECT_ID[platformKey];
    const selectedSource =
        IMAGE_SOURCE_OPTIONS.find((opt) => opt.value === (payload.imageSource ?? "random")) ??
        IMAGE_SOURCE_OPTIONS[0];
    const helperText =
        platformKey === "INSTAGRAM_IMAGE_POST"
            ? "Instagram always posts the standalone illustration. Jigsaw/sliding board images are not used."
            : `${selectedSource.description} Facebook posts this as a public Page photo (not a link card).`;

    return (
        <>
            <FormControl fullWidth size="small">
                <InputLabel id={selectId}>Which image to post</InputLabel>
                <Select
                    labelId={selectId}
                    label="Which image to post"
                    value={payload.imageSource ?? "random"}
                    onChange={(e) => onPayloadChange({ ...payload, imageSource: e.target.value })}
                >
                    {IMAGE_SOURCE_OPTIONS.map((opt) => (
                        <MenuItem key={opt.value} value={opt.value}>
                            {opt.label}
                        </MenuItem>
                    ))}
                </Select>
                <FormHelperText>{helperText}</FormHelperText>
            </FormControl>
            <FormControlLabel
                control={
                    <Switch
                        checked={Boolean(payload.fullSizeImage)}
                        onChange={(e) =>
                            onPayloadChange({ ...payload, fullSizeImage: e.target.checked })
                        }
                    />
                }
                label="Full-size image"
            />
        </>
    );
}

export default function TaskSchedulerPayloadFields({ type, payload, onPayloadChange }) {
    if (type === "INSTAGRAM_IMAGE_POST" || type === "FACEBOOK_IMAGE_POST") {
        return (
            <ImagePostPayloadFields
                platformKey={type}
                payload={payload}
                onPayloadChange={onPayloadChange}
            />
        );
    }

    if (type === "WORD_WHEEL_FACEBOOK_POST") {
        return (
            <FormControl fullWidth size="small">
                <InputLabel id="ww-fb-language-label">Puzzle language</InputLabel>
                <Select
                    labelId="ww-fb-language-label"
                    label="Puzzle language"
                    value={payload.language ?? "english"}
                    onChange={(e) => onPayloadChange({ ...payload, language: e.target.value })}
                >
                    <MenuItem value="english">English</MenuItem>
                </Select>
                <FormHelperText>
                    Posts at most 2 guess-words per day. The first uses the letter wheel; the second
                    shows the puzzle grid instead of the wheel.
                </FormHelperText>
            </FormControl>
        );
    }

    if (type === "PROMOTION_EMAIL") {
        return (
            <FormHelperText sx={{ mx: 0 }}>
                Sends every promotion email with status READY_TO_SENT. After a successful send the
                promotion becomes SENT, so a later job will not send it again. No payload required.
            </FormHelperText>
        );
    }

    if (type === "WEEKLY_EMAIL") {
        return (
            <FormHelperText sx={{ mx: 0 }}>
                Sends the weekly puzzle email saved on Advertisement → Promotion → Weekly email.
                English is the only template for now. A later language uses English until that language is saved.
                No payload required.
            </FormHelperText>
        );
    }

    return null;
}
